import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import AdminLayout from "./components/AdminLayout";
import Kiosk from "./pages/Kiosk";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Workers from "./pages/Workers";
import Records from "./pages/Records";
import Summary from "./pages/Summary";
import Settings from "./pages/Settings";
import Holidays from "./pages/Holidays";
import History from "./pages/History";
import SickLeave from "./pages/SickLeave";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Kiosk />} />
          <Route path="/history" element={<History />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="workers" element={<Workers />} />
            <Route path="records" element={<Records />} />
            <Route path="summary" element={<Summary />} />
            <Route path="holidays" element={<Holidays />} />
            <Route path="sick-leave" element={<SickLeave />} />
            <Route path="settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
